import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import {
  ref,
  onMounted,
  defineComponent,
  reactive,
  computed,
} from "@vue/composition-api";
import { itemRouteBuilder, NamedRts } from "@/router";

export default defineComponent({
  name: "clientShow",
  components: {
    LoadingAnimation,
  },
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Client...");

    const client = computed(() => {
      return $store.getters.client;
    });

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientEditForm, id);
    };

    const clientFieldShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientFieldShow, id);
    };

    const workOrderShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.workOrderDetails, id);
    };

    const firstPhoneNumber = computed(() => {
      if (client.value.phone_numbers.length > 0) {
        return client.value.phone_numbers[0];
      } else {
        return {
          number: "000000000",
        };
      }
    });

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.clientId,
      };

      $store.dispatch("needClient", jsConn).then(() => {
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,

      client,
      firstPhoneNumber,
      editRouteBuilder,
      clientFieldShowRouteBuilder,
      workOrderShowRouteBuilder,
    };
  },
});
